import { maintenanceStandardAssetsFiltersActions } from './maintenanceStandardAssets.actions';

const maintenanceStandardAssetsFiltersInitialState = {
    currentCostCenter: null,
    currentSearch: null,
    isLoadingData: false,
    paginatorPage: 1,
    isSearchByChildAsset: false,
};

export const assetsFiltersReducer = (state = maintenanceStandardAssetsFiltersInitialState, { type, payload }) => {
    switch (type) {
        case maintenanceStandardAssetsFiltersActions.SET_CURRENT_COST_CENTER: {
            return {
                ...state,
                currentCostCenter: payload,
            };
        }
        case maintenanceStandardAssetsFiltersActions.SET_IS_SEARCH_BY_CHILD_ASSET: {
            return {
                ...state,
                isSearchByChildAsset: payload,
            };
        }
        case maintenanceStandardAssetsFiltersActions.SET_SEARCH_VALUE: {
            return {
                ...state,
                currentSearch: payload,
            };
        }
        case maintenanceStandardAssetsFiltersActions.SET_IS_LOADING_DATA: {
            return {
                ...state,
                isLoadingData: payload,
            };
        }
        case maintenanceStandardAssetsFiltersActions.SET_PAGINATOR_PAGE: {
            return {
                ...state,
                paginatorPage: payload,
            };
        }
        case maintenanceStandardAssetsFiltersActions.RESET_ASSETS_FILTERS: {
            return {
                ...state,
                ...maintenanceStandardAssetsFiltersInitialState,
            };
        }

        default:
            return state;
    }
};
